<script lang="ts">
	import { createToggleGroup, melt } from '@melt-ui/svelte';
	import Checkbox from './Checkbox.svelte';

	interface Props {
		choice: boolean;
	}

	let { choice = $bindable() }: Props = $props();

	const {
		elements: { root, item },
		states: { value }
	} = createToggleGroup({
		type: 'single',
		onValueChange: ({ next }) => {
			choice = next === 'yes';
			return next;
		},
		defaultValue: choice === true ? 'yes' : choice === false ? 'no' : undefined
	});
</script>

<div use:melt={$root} class="grid gap-3 lg:grid-cols-2">
	<button class="toggle-item" use:melt={$item('yes')} aria-label="Yes" disabled={$value === 'yes'}>
		<Checkbox checked={$value === 'yes'} />
		<p class="body-bold">Yes</p>
	</button>

	<button class="toggle-item" use:melt={$item('no')} aria-label="No" disabled={$value === 'no'}>
		<Checkbox checked={$value === 'no'} />
		<p class="body-bold">No</p>
	</button>
</div>

<style lang="postcss">
	@reference '../../../app.css';

	.toggle-item {
		@apply flex items-center rounded-md border-1 border-[#007dcb] p-5;
	}

	.toggle-item[data-disabled] {
		@apply cursor-not-allowed;
	}

	.toggle-item[data-state='on'] {
		@apply border-[#007dcb] bg-[#007dcb]/10;
	}
</style>
